<div class="flex gap-2">
  @for (item of chips; track item.name) {
    <vdw-input-chip [value]="item.name" [canShowBMSTheme]="true"></vdw-input-chip>
  }
</div>
